import { UpdateHighlighter } from "@rarible_int/anaconda_ui_components"
import { cn } from "@rarible_int/anaconda_ui_components"

interface Props {
  value: number
  className?: string
}

const countFormatter = new Intl.NumberFormat("en-US")

export function Count(props: Props) {
  return (
    <UpdateHighlighter
      className={cn("text-nowrap", props.className)}
      value={props.value}
    />
  )
}

export function StatisticCount(props: Props) {
  return (
    <span className={cn("text-nowrap", props.className)}>
      {countFormatter.format(props.value)}
    </span>
  )
}
